import { AutoComplete, Button, Col, Dropdown, Flex, Input, Row, Select, Space, Radio } from "antd"
import References from "../../helpers/Reference"
import AuthService from "../../helpers/auth"
import { convertBlobFrom64, ConvertBlobFrom64, findIndexInJSONArray, findInJSONArray, saveFileDirectly } from "../../helpers/helpers"
import { useEffect, useState } from "react"
import { loadStationsMCHReport, searchStation } from "./utils"
import { DownOutlined } from "@ant-design/icons"
import { CustomDatepicker } from "../datepicker/custom.datepicker"
import dayjs from 'dayjs'
import { useAuth } from "../Auth/store"

export const ReportMCH = ({onStartReport, onFinishReport}) => {

    const {isAuth, permission} = useAuth();
    
    const [stations, setStations] = useState({})
    const [station, setStation] = useState()

    const [mchs, setMchs] = useState([])
    const [mch, setMch] = useState([])

    const [start, setStart] = useState(dayjs().subtract(1, 'day').startOf('day'))
    const [finish, setFinish] = useState(dayjs().startOf('day'))
    
    const [stationOptions, setStationOptions] = useState([])

    const [disabled, setDisabled] = useState(true)
    const [loading, setLoading] = useState(false)

    const [encoding, setEncoding] = useState(References.dictionary.encoding)

    useEffect(
        () => {
            loadStationsMCHReport()
            .then(data => {
                setStations(data)
                setStationOptions(Object.keys(data).map(uuid => {
                    return {
                        uuid: uuid,
                        label: data[uuid].name,
                        value: uuid
                    }
                }))
            })
        }, 
    []
    )

    const onReport = () => {

            setLoading(true)
            setDisabled(true)
            onStartReport()

            const req = {
                "report_type": "measurement",
                "report_date_from": dayjs(start, References.dateTimeFormat).format(),
                "report_date_to": dayjs(finish, References.dateTimeFormat).format(),
                "data_format": "csv",
                "mch_kind": "mchs",            
                "station_uuid": station,
                "mch_type": mch.type,
                "mch_uuid": mch.uuid,
                "encoding": encoding
            }

            AuthService.post(References.api.report_mch, req)
            .then(res => res.json())
            .then(data => saveFileDirectly(data.file_name, convertBlobFrom64(data.content_b64)))
            .catch(e => console.log(e.message))            
            .finally(() => {
                setLoading(false)
                setDisabled(false)
                onFinishReport()
            })
    }

    const onStationSelect = (val) => {
        const mchs = stations[val]?.mchs
        setStation(val)
        setMchs(() => {
            const result = [];
            const types = Object.keys(mchs);
            types.forEach(type => {
                Object.keys(mchs[type]).forEach(mch => {
                    result.push({
                        label: mchs[type][mch].name,
                        uuid: mch,
                        value: mch,
                        type: type,
                    })
                }) 
            })
            setMch(result[0])
            return result
        })
        setDisabled(false)
    }

    const onMCHSelect = (_, option) => {
        setMch(option)
    }

    const onStartOk = (val) => {
        setStart(val)
    }

    const onFinishOk = (val) => {
        setFinish(val)
    }

    const onChangeEncoding = (e) => {
        setEncoding(e.target.value)
    }

    if (!isAuth)
        return <></>

    return (
        <>
            <div className="mt-2">
                <Select
                    options={stationOptions}
                    onChange={onStationSelect}
                    className="w-100"
                    placeholder={References.dictionary.station}
                    showSearch
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }     
                    disabled={loading}                                               
                />                         
            </div>

            <div className="mt-2">
                <Select
                    options={mchs}
                    value={mch?.uuid}
                    onChange={onMCHSelect}
                    className="w-100"
                    placeholder={References.dictionary.mch}
                    disabled={loading || !station}                                 
                />                         
            </div>

            <div className="mt-2">
                <CustomDatepicker  
                    isCustom={false} 
                    start={start} 
                    finish={finish} 
                    disabledStart={loading}
                    disabledFinish={loading}
                    onStart={onStartOk} 
                    onFinish={onFinishOk}
                />                
            </div>
            <div>

            <div className="mt-2 radio-in-row">
            <Radio.Group
            onChange={onChangeEncoding}
            value={encoding}
            options={[
                {
                value: "windows-1251",
                label: (
                    <div>
                    Windows-1251
                    </div>
                ),
                },
                {
                value: "utf-8",
                label: (
                    <div>
                    UTF-8
                    </div>
                ),
                },
            ]}
            />
            </div>
            </div>
            <div className="mt-2">
                <Button onClick={onReport} style={{width: "100%"}} type="primary" loading={loading} disabled={disabled}>Выполнить</Button>
            </div>
        </>
    )
}